import { useState } from 'react';
import Sidebar from '../components/sidebar';
import HeaderBar from '../components/headerbar';

const DashboardLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-slate-950">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <div
        className={`flex-1 transition-all duration-300
        ${collapsed ? "ml-16" : "ml-64"}`}
      >
        {/* Header */}
        <HeaderBar />

        {/* Page Content */}
        <main className="p-6 text-white">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
